import React, { Component, ReactElement, useState } from "react";

import PageLayout from '../../components/layout/PageLayout'
import { ThemeProps } from "../../components/styles/themeprops";
import { Fade } from "react-awesome-reveal";
import "./impressum.css";
import ImprintImg from "./imprintImg";
import { handleLogError } from "../../components/misc/Helpers";
import { useTranslation } from "react-i18next";

type Props = { theme: ThemeProps, }
export default function Service({ theme }: Props) {


	const { t, i18n } = useTranslation();

	return (
		<PageLayout title="Home" theme={theme}>
			<div className="imprint">
				<div className="basic-projects">
					<Fade direction="left" duration={1000} damping={0.3} triggerOnce={true}>
						<div className="projects-heading-div">
							<div className="imprint-heading-img-div">
								{/* <img
											src={require(`../../assests/images/${projectsHeader["avatar_image_path"]}`)}
											alt=""
										/> */}
								<ImprintImg theme={theme} />
							</div>
							<div className="projects-heading-text-div">
								<h1 className="projects-heading-text">{t("imprint.title")}</h1>
								<p className="projects-header-detail-text subTitle">
									{t("imprint.description")}
								</p>
							</div>
						</div>
					</Fade>
				</div>
			</div>


			<div className="contact-form-div imprint">
				<h1 className="d-flex justify-content-center">{t("imprint.title")}</h1>

				<div className="row d-flex align-items-center justify-content-center h-100">
					<div className="col-md-3 col-lg-3 col-xl-3"></div>
					<div className="col-md-6 col-lg-6 col-xl-6 ">
						<div className="float-end"></div>

						<p>Die Website ViBeRu.de wird betrieben von der</p>
						<p>
							ViBeRu<br />
							QuerStr 10<br />
							61206 Illbenstadt<br />
							Deutschland
						</p>
						<p>
							Tel.: +49 231 5599-00<br />
							Fax: +49 231 5599-100<br />
							E-Mail: <a href="mailto:marketing@viberu.de" className="ContactData" title="Emailan">
								<span style={{ color: 'var(--primary)' }}>info@viberu.de&#160;</span><i className="fa-solid fa-envelope" style={{ color: 'var(--primary)' }}></i></a>, unsere Internet-Redaktion erreichen Sie unter
							<a href="mailto:internet-redaktion@materna.group" className="ContactData" title="Emailan">
								<span style={{ color: 'var(--primary)' }}>info@viberu.de&#160;</span><i className="fa-solid fa-envelope" style={{ color: 'var(--primary)' }}></i></a>.
						</p>
						<p>
							Amtsgericht <br />
							Umsatzsteueridentifikationsnummer:
						</p>
						<p>
							Vertretungsberechtigter Geschäftsführer: </p>

						<p>
							© 2023 ViBeRu</p>

						
						<h1 className="d-flex justify-content-center">Urheberrecht</h1>
						<p>
							Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis.
						</p>
						<p>Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</p>
						
						<h1 className="d-flex justify-content-center">Haftung für Inhalte</h1>
						<p>
							Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach § 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p>
						
						<h1 className="d-flex justify-content-center">Haftung für Links</h1>
						<p>
							Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
						</p>
						
					</div>
					<div className="col-md-3 col-lg-3 col-xl-3"></div>
				</div>

			</div>

		</PageLayout>
	);
}